var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "container"
  }, [_c("div", {
    staticClass: "title"
  }, [_c("span", {
    staticClass: "left",
    on: {
      click: _vm.back
    }
  }, [_vm._v("×")]), _c("span", {
    staticClass: "right",
    on: {
      click: _vm.getCountry
    }
  }, [_vm._v(_vm._s(_vm.country) + " "), _c("span", [_vm._v("▼")])])]), _c("div", {
    staticClass: "greetings"
  }, [_c("span", {
    staticClass: "top"
  }, [_vm._v("Login")]), _c("span", {
    staticClass: "center"
  }, [_vm._v("Hello! Welcome to MG")]), _c("span", {
    staticClass: "bottom"
  }, [_vm._v("Don't have an account yet?"), _c("span", {
    on: {
      click: _vm.toRefister
    }
  }, [_vm._v(" Register now")])])]), _c("div", {
    staticClass: "login-con"
  }, [_c("div", {
    staticClass: "login-box"
  }, [_c("div", {
    staticClass: "account"
  }, [_c("span", {
    staticClass: "top"
  }, [_vm._v("Account")]), _c("div", {
    staticClass: "bottom"
  }, [_c("span", {
    on: {
      click: _vm.getCountry
    }
  }, [_vm._v(_vm._s(_vm.countryCode) + " "), _c("span", [_vm._v("▼")])]), _c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.userName,
      expression: "userName"
    }],
    attrs: {
      type: "text",
      placeholder: "Enter Phone/Email"
    },
    domProps: {
      value: _vm.userName
    },
    on: {
      input: [function ($event) {
        if ($event.target.composing) return;
        _vm.userName = $event.target.value;
      }, _vm.input],
      focus: function focus($event) {
        return _vm.focus(".account .bottom");
      },
      blur: function blur($event) {
        return _vm.blur(".account .bottom");
      }
    }
  })])]), _c("div", {
    staticClass: "password"
  }, [_c("span", {
    staticClass: "top"
  }, [_vm._v("Verification Code")]), _c("div", {
    staticClass: "bottom"
  }, [_c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.verificationCode,
      expression: "verificationCode"
    }],
    attrs: {
      type: "text",
      placeholder: "Enter Verification Code"
    },
    domProps: {
      value: _vm.verificationCode
    },
    on: {
      input: [function ($event) {
        if ($event.target.composing) return;
        _vm.verificationCode = $event.target.value;
      }, _vm.input],
      focus: function focus($event) {
        return _vm.focus(".password .bottom");
      },
      blur: function blur($event) {
        return _vm.blur(".password .bottom");
      }
    }
  }), _c("span", {
    staticClass: "send-btn",
    on: {
      click: _vm.send
    }
  }, [_vm._v(_vm._s(_vm.$t("send")))])])]), _c("div", {
    staticClass: "forget-password"
  }, [_c("span", {
    staticStyle: {
      visibility: "hidden"
    }
  }, [_vm._v("Forgot Password")]), _c("span", {
    on: {
      click: _vm.toLoginWithPassword
    }
  }, [_vm._v("Account Password")])])]), _c("div", {
    class: ["btn", {
      active: _vm.isActive
    }],
    on: {
      click: _vm.toLogin
    }
  }, [_vm._v("Login")]), _c("div", {
    staticClass: "argeement"
  }, [_c("van-checkbox", {
    attrs: {
      "icon-size": "18px",
      "checked-color": "#6EDCF5"
    },
    model: {
      value: _vm.checked,
      callback: function callback($$v) {
        _vm.checked = $$v;
      },
      expression: "checked"
    }
  }), _vm._m(0)], 1)])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "txt"
  }, [_vm._v("Agree to the "), _c("span", [_vm._v("User Agreement")]), _vm._v(" and "), _c("span", [_vm._v("Privacy Policy")])]);
}];
render._withStripped = true;
export { render, staticRenderFns };